import styled from 'styled-components'
import { Link } from 'gatsby'

export const styleResponsive = {
  bmMenuWrapp: {
    width: '200px'
  },
  bmBurgerButton: {
    position: 'fixed',
    width: '25px',
    height: '20px',
    right: '10px',
    top: '18px',
    zIndex: '1020'
  },
  bmBurgerBars: {
    background: '#008de6'
  },
  bmCrossButton: {
    height: '24px',
    width: '24px'
  },
  bmCross: {
    background: 'white'
  },
  bmMenu: {
    background: '#008de6',
    padding: '2.5em 1.5em 0',
    fontSize: '1.15em'
  },
  bmMorphShape: {
    fill: '#008de6'
  },
  bmItemList: {
    color: 'white'
  },
  bmItem: {
    display: 'flex',
    outline: 'none'
  }
}

export const MenuLink = styled(Link)`
  color: #ccc;
  text-decoration: none;
  cursor: pointer;
`

export const SubmenuLink = styled(Link)`
  color: #ccc;
  text-decoration: none;
  margin-left: 20px;
  cursor: pointer;
`

export const TitleMenu = styled.span`
  color: white;
  font-weight: bold;
`
